import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Show from "../views/Show"
import Faq from "../views/pages/Faq"
import Partners from "../views/pages/Partners";
import Hotels from "../views/pages/Hotels";
import Advices from "../views/pages/Advices";
import Contact from "../views/pages/Contact";
import JoinUs from "../views/pages/JoinUs";
import Escort from "../views/pages/Escort";
import BlogShow from "../views/BlogShow";
import Blog from "../views/Blog";
import Banner from "../views/pages/Banner";

Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/girl/:id-:slug',
        name: 'Show',
        component: Show
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: Faq

    },
    {
        path: '/partners',
        name: 'Partners',
        component: Partners
    },
    {
        path: '/hotels',
        name: 'Hotels',
        component: Hotels
    },
    {
        path: '/advices',
        name: 'Advices',
        component: Advices
    },
    {
        path: '/join-us',
        name: 'JoinUs',
        component: JoinUs
    },
    {
        path: '/banner',
        name: 'Banner',
        component: Banner
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/escort/:slug',
        name: 'Escort',
        component: Escort
    },
    {
        path: '/blog',
        name: 'Blog',
        component: Blog
    },
    {
        path: '/blog/:slug',
        name: 'BlogShow',
        component: BlogShow
    },
    {
        path: '/**',
        redirect: {name: 'Home'}
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
